module.exports = __webpack_public_path__ + "static/media/payrolltelegram.0d708a78.svg";